import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import jwtEncode from "jwt-encode";
import AssetViewer from "../3DModel/assetViewer.js";
import { DownloadIcon, HeadBackIcon, LinkIcon, SideArrow } from "../../Assets/Icons";
import apiClient from "../../apiClient";
import { GET_ASSET_DETAILS } from "../../apiClient/apiEndPoints";
import { getWindowDimensions, handleLogin } from "../../utils/common";

const DetailedAsset = () => {
  const params = useParams();
  const navigate = useNavigate();
  const { id } = params;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const tagsData = useSelector((state) => state.tagsSlice);
  const [geometryTags, setGeometryTags] = useState([]);
  const [heirarchy, setHeirarchy] = useState([]);
  const [attributesTags, setAttributesTags] = useState([]);
  const [assetDetails, setAssetDetails] = useState(null);
  const [platform, setPlatform] = useState("universal");
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    setTimeout(() => setCopied(true), 100);
    await navigator.clipboard.writeText(window.location.href);
    setTimeout(() => setCopied(false), 2500);
  };

  const getAssetDetail = async () => {
    try {
      let type = userData.token ? "private" : "public";

      let data = await apiClient(`${configData.config.UNO_URL}${GET_ASSET_DETAILS}/${type}/${platform}/${id}`);
      setAssetDetails(data);
      let geometryTags = tagsData?.assetTagsList?.children?.find((e) => e.name === "geometryTag");
      let assetAttributesTags = tagsData?.assetTagsList?.children?.find((e) => e.name === "assetAttributesTag");
      let geoTags = data.tags.filter((e) => e.categoryId === geometryTags?.id);
      let assetTags = data.tags.filter((e) => e.categoryId === assetAttributesTags?.id);
      setGeometryTags(geoTags);
      setAttributesTags(assetTags);
      setHeirarchy(data.heirarchy);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getAssetDetail();
  }, [id, tagsData]);

  const availableFormate = Array.from(
    new Set(assetDetails?.allAssetVersions?.map((item, index) => item?.data?.assets?.[0]?.type))
  ).join(", ");

  let availableAssets =
    assetDetails?.allAssetVersions?.reduce((acc, ele) => {
      if (!acc[ele?.data?.type]) acc[ele?.data?.type] = ele?.data;
      return acc;
    }, {}) || {};
  availableAssets = Object.values(availableAssets);

  const [screenMobile, setScreenMobile] = useState(true);

  const handleResize = () => {
    const { mode } = getWindowDimensions();
    setScreenMobile(mode === "Landscape" ? false : true);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleBackButton = () => {
    if (userData.token) {
      navigate(-1);
    } else {
      handleLogin(configData.config.redirectUri, jwtEncode);
    }
  };

  return (
    <>
      <div className="asset-view">
        {screenMobile ? (
          <span className="back-mobile" onClick={handleBackButton}>
            <HeadBackIcon />
          </span>
        ) : (
          <>
            {userData.token && (
              <div className="bread-crumb">
                {heirarchy.map((e, i) => {
                  return (
                    <>
                      <p
                        className={heirarchy.length === parseInt(i) + 1 ? "active" : ""}
                        onClick={() => navigate(`/category/${e.id}`)}
                      >
                        {configData.config["3dAssetsId"] === e.id ? "All Category" : e.name}
                      </p>
                      {heirarchy.length != parseInt(i) + 1 && (
                        <span>
                          {" "}
                          <SideArrow />{" "}
                        </span>
                      )}
                    </>
                  );
                })}
              </div>
            )}
          </>
        )}

        <div className="threeD-details">
          <div className="three-view">
            <div className="share-btn-parent">
              <span className="share-btn" onClick={handleCopy}>
                <span className={copied ? "copynow done" : "copynow"}>
                  <LinkIcon />
                  Copy Link
                </span>
                <span className={copied ? "copied show" : "copied"}>Copied!</span>
              </span>
            </div>

            <AssetViewer assetDetails={assetDetails} />
          </div>
          <div className="asset-details">
            <div className="asset-main">
              <div className="asset-name">
                <h6> {assetDetails?.name} </h6>
              </div>
              <div className="asset-infos">
                <p>
                  {" "}
                  Release Date
                  <span>{assetDetails?.createdAt && moment(assetDetails?.createdAt).format("DD MMMM YYYY")}</span>
                </p>

                <p>
                  {" "}
                  Geometry
                  {geometryTags.length > 0 ? (
                    geometryTags.map((item, id) => {
                      return <span key={item.id}>{item.name}</span>;
                    })
                  ) : (
                    <span> NA </span>
                  )}
                </p>

                <p>
                  {" "}
                  Polygons
                  <span>{assetDetails?.versions[0]?.data?.polygons || "NA"}</span>
                </p>

                <p>
                  {" "}
                  Vertices
                  <span>{assetDetails?.versions[0]?.data?.vertices || "NA"}</span>
                </p>

                <p>
                  {" "}
                  Attributes
                  <div className="tag-shown" style={{ display: "flex", gap: "0.3rem" }}>
                    {attributesTags.length > 0 ? (
                      attributesTags.map((item, id) => {
                        return <span key={item.id}> {item.name}</span>;
                      })
                    ) : (
                      <span> NA </span>
                    )}
                  </div>
                </p>

                <p>
                  {" "}
                  Format
                  <span>{availableFormate}</span>
                </p>

                <div className="tags">
                  {assetDetails?.tags?.map((item, index) => (
                    <span key={index}> {item.name} </span>
                  ))}
                </div>
              </div>
            </div>
            {userData.token && (
            <div className="download-options pt-5">
              {availableAssets?.map((item, index) => (
                <button key={index} class="button" type="button">
                  <span class="button__text">Download {item.assets[0].type}</span>
                  <span
                    class="button__icon"
                    onClick={() => {
                      const link = document.createElement("a");
                      link.href = item?.assets[0]?.url;
                      link.download = item?.assets[0]?.url?.split("/")?.pop(); 
                      link.click();
                    }}
                  >
                    <DownloadIcon />
                  </span>
                </button>
              ))}
            </div>)}
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailedAsset;
